@switch (column()?.definition.input) {
    @case (InputTypeEnum.Toggle) {
        <!-- <wk-toggle-input [value]="item().fields[column.fieldname]" (valueChange)="item().updateField(column.fieldname, $event)" /> -->
    }
    @default {
        @let castValue = value();
        @if (column?.()?.isSafeValue(castValue)) {
            <div class="wk-data-table__cell__value" [innerHTML]="value()"></div>
        } @else {
            <div class="wk-data-table__cell__value">{{ value() }}</div>
        }
    }
}
